var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("icon-view", {
        attrs: {
          gradient: "",
          icon: "fa fa-book font-14",
          "icon-background": "#FFF",
          "icon-color": "#FF7058",
          title: "Bitácora"
        }
      }),
      _vm.items.length === 0 && !_vm.showAdd
        ? _c("div", { staticClass: "bg-secondary-13 rounded py-3 mt-3" }, [
            _c(
              "div",
              { staticClass: "row d-flex justify-content-center" },
              [
                _c("action-button", {
                  staticClass: "border w-40 btn bg-white",
                  attrs: {
                    id: "btnAdd",
                    i: "fas fa-file-plus color-primary-1",
                    text: "Presione aquí para añadir bitácora"
                  },
                  on: {
                    click: function($event) {
                      _vm.showAdd = !_vm.showAdd
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.showAdd
        ? _c(
            "div",
            { staticClass: "bg-secondary-13 rounded py-3 px-4 mt-3" },
            [
              _c(
                "validation-observer",
                { ref: "formRef", attrs: { novalidate: "", tag: "form" } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "color-black font-14 my-1" },
                                [_vm._v("Bitácora de Intervención:")]
                              ),
                              _c("custom-text-area", {
                                attrs: {
                                  id: "txtComment",
                                  "count-classes": [
                                    "d-block",
                                    "small-counter",
                                    "text-right"
                                  ],
                                  "custom-error-msg":
                                    "Favor escriba un comentario de la intervención realizada.",
                                  error: errors[0],
                                  maxlength: 3000,
                                  placeholder: "Escribe un comentario",
                                  "show-char-count": ""
                                },
                                model: {
                                  value: _vm.model.comment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "comment", $$v)
                                  },
                                  expression: "model.comment"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3965251629
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-end align-items-center mt-4"
                },
                [
                  _c("action-button", {
                    attrs: {
                      id: "btnCancel",
                      i: "fas fa-times-circle",
                      text: "Cancelar",
                      variant: "outline-danger mr-3 px-3"
                    },
                    on: { click: _vm.onCancelHandler }
                  }),
                  _c("action-button", {
                    attrs: {
                      id: "btnSave",
                      i: "fas fa-save",
                      text: "Guardar",
                      variant: "success px-3"
                    },
                    on: { click: _vm.onSaveHandler }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _vm._l(_vm.items, function(item, index) {
            return _c(
              "div",
              {
                key: `item-${index}`,
                staticClass:
                  "d-flex flex-column flex-md-row mb-3 bg-secondary-13 rounded py-3 px-4 mt-3"
              },
              [
                _c("div", { staticClass: "col pr-5 border-right" }, [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("em", {
                      staticClass: "fas fa-circle mr-2",
                      class: `color-${_vm.statusColor(item.billingStatusId)}`
                    }),
                    _c(
                      "span",
                      { staticClass: "color-black font-14 font-weight-bold" },
                      [_vm._v(" " + _vm._s(item.billingStatusName) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "mt-2" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v("Fecha:")
                    ]),
                    _c("div", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formatCreatedDate(item.createdDate)) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "mt-2" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v("Añadido por:")
                    ]),
                    _c("div", { staticClass: "font-16 color-black" }, [
                      _vm._v(_vm._s(item.createdByUserName))
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-10 mt-2 mt-md-0 pl-0 pl-md-4" }, [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "color-secondary-6 font-14 mb-2" },
                      [_vm._v("Comentario:")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white px-4 py-2 rounded border-color--gray-5"
                      },
                      [
                        _c("p", [_vm._v(_vm._s(_vm.itemComment(item)))]),
                        _vm.showReadMore(item.comment)
                          ? _c(
                              "div",
                              {
                                staticClass: "text-right cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.onShowMoreTextHandler(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "color-green mr-2" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.readText(item.showFullText)
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("em", {
                                  class: `color-green ${_vm.readIcon(
                                    item.showFullText
                                  )}`
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ])
              ]
            )
          }),
          _vm.showAddAction
            ? _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("action-button", {
                    attrs: {
                      id: "btnAddEntry",
                      i: "fas fa-file-plus",
                      text: "Añadir",
                      variant: "success pl-4 pr-4"
                    },
                    on: {
                      click: function($event) {
                        _vm.showAdd = !_vm.showAdd
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showPagination
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center mt-3"
                },
                [
                  _c("action-button", {
                    staticClass: "btn-see-more",
                    attrs: {
                      i: "fas fa-chevron-down",
                      text: "Ver más",
                      variant: "outline-success rounded-pill px-5"
                    },
                    on: { click: _vm.onLoadMoreHandler }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }